import {Check} from "@sparkware/app-utils";
import {Color} from "../../../../common/utils/color-util";
import {IButtonColor, IButtonColorSet, IButtonColorSetDef} from "./button-props.interface";

export function hoverColor(hex: string, hoverAdjustAmount: number = 17) {
    try {
        const color = Color.fromHex(hex);
        // i chose 60 here because it's a value close to sqrt(35^2 + 35^2 + 35^2)
        if (color.distanceFrom(new Color(255, 255, 255)) < 60) {
            return color.darken(hoverAdjustAmount).hexa();
        }
        return color.lighten(hoverAdjustAmount).hexa();
    } catch (e) {
        console.log(e);
        console.log("HOVER COLOR WAS CALLED WITH: ", hex);
        return hex;
    }
}

export function hoverGradient(gradient: string, hoverAdjustAmount?: number) {
    const clrs = gradient.split("#");
    if (clrs.length > 1) {
        for (let i = 1; i < clrs.length; i++) {
            const hexClr = clrs[i].substring(0, 6);
            // get the hover color and remove # because we will add when joining
            const hexHoverClr = hoverColor(hexClr, hoverAdjustAmount).substring(1);
            clrs[i] = hexHoverClr + clrs[i].substring(6);
        }
        return clrs.join("#");
    }
    return gradient;
}

export function computeColorSet(colorSet: IButtonColorSetDef, defaultDisabled: IButtonColor): IButtonColorSet {
    const hoverAdjustAmount = Check.isNumber(colorSet.hover) ? colorSet.hover : undefined;
    if (Check.isNumber(colorSet.hover)) {
        // I need to clone the colorSet otherwise I will delete hover globally (colorSet is passed by reference)
        colorSet = {
            ...colorSet
        };
        delete colorSet.hover;
    }

    let hoverBgGradient = undefined;
    if (colorSet.normal.bgGradient) {
        hoverBgGradient = hoverGradient(colorSet.normal.bgGradient, hoverAdjustAmount);
    }
    const defaultHover: IButtonColor = {
        ...colorSet.normal,
        bg: hoverColor(colorSet.normal.bg, hoverAdjustAmount),
        border: hoverColor(colorSet.normal.border, hoverAdjustAmount),
        bgGradient: hoverBgGradient
    };
    /**
     * I get a weird Typescript bug probably because interfaces IButtonColorSet and IButtonColorSetDef.
     * It says that type number is not assignable to IButtonColor but defaultHover cannot be number and is not defined as number.
     * I cast it as any
     */
    const cset: IButtonColorSet = {
        disabled: defaultDisabled,
        hover: defaultHover as any,
        ...colorSet,
    }
    return cset
}
